import { render, staticRenderFns } from "./SuccessfullPayment.vue?vue&type=template&id=51b245f7&"
import script from "./SuccessfullPayment.vue?vue&type=script&lang=js&"
export * from "./SuccessfullPayment.vue?vue&type=script&lang=js&"
import style0 from "./SuccessfullPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports